<template>
  <div class="exam_answer_sheet">
    <div class="answer_sheet flex flexcolumn Flexalign mb-30" v-if="!hideCountDown">
      <div class="flex Flexalign exam_time">
        <el-image class="timehours_icon mt-5" :src="imgPath('timehours_icon.png')"></el-image>
        <div class="ml-10">总剩余时间</div>
      </div>
      <div class="exam_countDown mt-10">
        {{ $Tools.convertMinutesToCountdown(countDown) }}
      </div>
    </div>
    <div class="answer_sheet">
      <div class="answer_top" v-if="examType == 'practice'">
        <div class="answer_title">答题卡</div>
      </div>
      <div class="answer_top" v-if="examType == 'record'">
        <div class="flex FlexBaseline testExam_score Flexjustify">
          <div class="testExam_score_value">{{ testExamInfo.score }}</div>
          <div>分</div>
        </div>
        <div class="flex FlexBaseline Flexjustify">
          <el-image class="homework_score_icon" :src="iconPath('homework_score_icon.png')"></el-image>
        </div>
        <div class="marker_info px-15 py-20" v-if="testExamInfo.markerComment">
          <div class="flex Flexalign FlexWrap marker_info_content">
            <el-image class="comments_icon mr-10" :src="iconPath('comments_icon.png')"></el-image>
            <!-- <div class="" v-html="testExamInfo.markerComment" @click="handleImageClick"></div> -->
            <priviewImg :richText="testExamInfo.markerComment"></priviewImg>
          </div>
        </div>
        <div class="marker_reviewer flex Flexalign mt-10" v-if="testExamInfo.markerName">
          <div class="reviewer_label">批阅人：</div>
          <div class="reviewer_value">{{ testExamInfo.markerName }}</div>
        </div>
        <div class="marker_reviewer flex Flexalign mt-10" v-if="testExamInfo.markTime">
          <div class="reviewer_label">批阅时间：</div>
          <div class="reviewer_value">{{ testExamInfo.markTime }}</div>
        </div>
      </div>
      <div class="progress_classify flex FlexBetween mar_top_15" v-if="examType == 'practice' || examType == 'record'">
        <div class="classify_one flex Flexalign">
          <div class="complete_progress"></div>
          <div class="mar_left_10">
            {{ testExamInfo.isShowScoring ? "正确" : "已完成" }}
          </div>
        </div>
        <div class="classify_one flex Flexalign">
          <div class="incomplete_progress" :class="testExamInfo.isShowScoring ? 'wrong_progress' : ''"></div>
          <div class="mar_left_10">
            {{ testExamInfo.isShowScoring ? "错误" : "未完成" }}
          </div>
        </div>
        <div class="classify_one flex Flexalign">
          <div class="current_progress"></div>
          <div class="mar_left_10">
            {{ testExamInfo.isShowScoring ? "部分正确" : "当前" }}
          </div>
        </div>
      </div>
      <div class="topic_list mar_top_20" v-if="examType == 'practice' || examType == 'record'">
        <div class="topic_one mar_bottom_20" v-for="(item, index) in topicList" :key="index">
          <div class="topic_type">{{ item.topicType }}</div>
          <div class="topic_sub flex FlexWrap" v-if="!testExamInfo.isShowScoring">
            <div class="answer_block mar_top_10 cursor_pointer" v-for="(sitem, sindex) in item.subList" :key="sindex"
              :class="[
                sitem.status == 0
                  ? 'incomplete_progress'
                  : sitem.status == 1
                    ? 'complete_progress'
                    : 'current_progress',
              ]" @click="changeCurrentQuestionId(sitem.questionNumber)">
              {{ sitem.topicNum }}
            </div>
          </div>
          <div class="topic_sub flex FlexWrap" v-if="testExamInfo.isShowScoring">
            <div class="answer_block mar_top_10 cursor_pointer" v-for="(sitem, sindex) in item.subList" :key="sindex"
              :class="[
                sitem.isCorrect == 1
                  ? 'complete_progress'
                  : sitem.isCorrect == 2
                    ? 'wrong_progress'
                    : 'current_progress',
              ]" @click="changeCurrentQuestionId(sitem.questionNumber)">
              {{ sitem.topicNum }}
            </div>
          </div>
        </div>
      </div>
      <div class="topic_list mar_top_20" v-if="examType == 'wrongQuestion'">
        <div class="topic_one mar_bottom_20" v-for="(item, index) in topicList" :key="index">
          <div class="topic_type">{{ item.topicType }}</div>
          <div class="topic_sub flex FlexWrap">
            <div class="answer_block mar_top_10 cursor_pointer" v-for="(sitem, sindex) in item.subList" :key="sindex"
              :class="[
                testExamInfo.currentQuestionId == sitem.questionNumber
                  ? 'current_progress'
                  : 'complete_progress',
              ]" @click="changeCurrentQuestionId(sitem.questionNumber)">
              {{ sitem.topicNum }}
            </div>
          </div>
        </div>
      </div>
      <div class="commit_btn cursor_pointer" @click="commitPaper" v-if="
        !testExamInfo.isShowScoring &&
        ((examType == 'wrongQuestion' && isWrongReubmit) || schoolMenu != 4) &&
        schoolMenu != 3
      ">
        提交试卷
      </div>
      <div class="attention_text" v-if="!testExamInfo.isShowScoring && schoolMenu != 3">
        若有主观题，系统暂不支持自动判分
      </div>

      <aiWait ref="aiWait"></aiWait>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import priviewImg from "../richText/priviewImg.vue";
import aiWait from "../popup/aiWait.vue";
export default {
  name: "GjkcH5AnswerSheet",
  computed: {
    ...mapState({
      testExamInfo: (state) => state.exam.testExamInfo,
      testExamTime: (state) => state.exam.testExamTime,
      isChallengeSubmit: (state) => state.exam.isChallengeSubmit,
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
      challengeSort: (state) => state.exam.challengeSort,
    }),
  },
  components: { priviewImg, aiWait },
  props: {
    examType: {},
    schoolMenu: {}, // 用于判断是否是闯关，闯关不展示得分等信息
    isWrongReubmit: {}, // 用于控制错题重做还是练习，为true是重做，不展示组卷
    wrongTitle: {}, // 用于区分是经典错题还是用户错题，是否展示错题组卷按钮
    homeworkType: {}, // 用于区分是否是课后作业，课后作业接口要替换
    countDown: {},
    hideCountDown: {}, // 用于隐藏倒计时
    paperType: {}, // 用于区分考试提交还是能力测评提交
  },
  emits: ["refreshTextExam"], // 显式声明事件
  watch: {
    testExamTime: {
      handler(val) {
        if (val) {
          if (val.remainingTime <= 0) {
            this.commitPaper("timeout");
          }
        }
      },
      // immediate: true,
      deep: true,
    },
    testExamInfo: {
      handler() {
        this.organizeQuestionType();
        if (this.testExamInfo.isShowScoring) {
          // 计算总分
          this.getFinalScore();
        }
      },
      deep: true,
    },
  },
  unmounted() {
    this.$store.commit("exam/setTestExamTime", {});
  },

  data() {
    return {
      examInfo: {
        name: "",
        chapter: "",
        number: 20,
        duration: "",
        fullMark: 100,
      },
      topicList: [],
      finalScore: 0, // 总分
      paperCommitBackInfo: {}, // 闯关提交反馈结果
      loading: {},
    };
  },

  mounted() {
    this.organizeQuestionType();
  },

  methods: {
    getFinalScore() {
      this.finalScore = 0;
      this.testExamInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          this.finalScore += Number(sitem.score);
        });
      });
    },
    changeCurrentQuestionId(id) {
      // 闯关模式不允许答题卡切换
      if (this.isChallengeSubmit) return;
      this.$store.commit("exam/setCurrentQuestionId", id);
    },
    // 题型整理归纳
    organizeQuestionType() {
      this.topicList = [];
      if (this.$Tools.empty(this.testExamInfo)) return;
      const map = [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
        "十三",
        "十四",
        "十五",
        "十六",
        "十七",
        "十八",
        "十九",
        "二十",
        "二十一",
        "二十二",
        "二十三",
        "二十四",
        "二十五",
        "二十六",
        "二十七",
        "二十八",
        "二十九",
        "三十",
      ];
      this.testExamInfo.paperContext.forEach((item) => {
        let topicInfo = {
          topicType: "",
          subList: [],
          questionTypeId: "",
        };
        item.questions.forEach((sitem) => {
          let isInProgress = 0; // 1已完成，2，进行中，0未完成
          if (sitem.questionContext?.isFinish) {
            isInProgress = 1;
          } else {
            isInProgress = 0;
          }
          // 判断题目是不是当前题目
          if (sitem.questionNumber == this.testExamInfo.currentQuestionId) {
            isInProgress = 2;
          }
          // 查询题型是否已存在，存在则直接丢题目，否则创建题型列
          const currentIndex = this.topicList.findIndex(
            (ssitem) => item.questionTypeId == ssitem.questionTypeId
          );
          if (currentIndex != -1) {
            this.topicList[currentIndex].subList.push({
              ...sitem,
              topicNum: sitem.questionNumber,
              status: isInProgress,
            });
          } else {
            topicInfo.topicType = `${map[this.topicList.length]}、${item.questionTypeName
              }`;
            topicInfo.questionTypeId = sitem.questionTypeId;
            topicInfo.subList.push({
              ...sitem,
              topicNum: sitem.questionNumber,
              status: isInProgress,
            });
            this.topicList.push(topicInfo);
          }
        });
      });
    },
    // 提交试卷
    commitPaper(type) {
      let listParams = {
        paperId: this.testExamInfo.paperId,
        examId: this.testExamInfo.examId,
        isSubmit: 1, // 是否提交：1：提交 2：未提交保存进度,2现在改为最新后端判分处理
        questions: [],
      };
      // 测评作答参数有所不同
      if ((this.paperType == "testPaper") || (this.paperType == "examination")) {
        listParams = {
          paperId: this.testExamInfo.paperId,
          recordId: this.testExamInfo.recordId,
          isSubmit: 1, // 是否提交：1：提交 2：未提交保存进度,2现在改为最新后端判分处理
          questions: [],
        };
      }
      let isAllFinish = true;
      if (this.testExamInfo.examScene) {
        listParams.examScene = this.testExamInfo.examScene;
      }
      this.testExamInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          // 深拷贝当前题目数据
          const questionCopy = JSON.parse(JSON.stringify(sitem));

          // 这里处理下多选题的答案和用户答案的数据结构将数组转换成字符串
          if (questionCopy.questionTypeId == 2) {
            if (Array.isArray(questionCopy.questionContext.answer)) {
              questionCopy.questionContext.answer = questionCopy.questionContext.answer.join(",")
            }
            if (Array.isArray(questionCopy.questionContext.doAnswer)) {
              questionCopy.questionContext.doAnswer = questionCopy.questionContext.doAnswer.join(",")
            }
            if (Array.isArray(questionCopy.doAnswer)) {
              questionCopy.doAnswer = questionCopy.doAnswer.join(",")
            }
          }
          if (questionCopy.questionTypeId == 99 || questionCopy.questionTypeId == 101 || questionCopy.questionTypeId == 102 || questionCopy.questionTypeId == 103) {
            questionCopy.questionContext.subQuestions.forEach((ssitem) => {
              // 综合解答下的多选题
              if (ssitem.type == 2) {
                // let aaa = this.$Tools.copyObj(ssitem);
                // 判断题处理数据格式
                if (Array.isArray(ssitem.answer)) {
                  ssitem.answer = ssitem.answer.join(",")
                }
                if (Array.isArray(ssitem.doAnswer)) {
                  ssitem.doAnswer = ssitem.doAnswer.join(",")
                }
                // return aaa
              }
            });
          }
          // 作文题
          // 处理作文题序列化
          if (questionCopy.questionTypeId == 21 || questionCopy.questionTypeId == 22) {
            questionCopy.questionContext.doAnswer = JSON.stringify(questionCopy.doAnswer);
          }
          listParams.questions.push(questionCopy);
        });
      });
      if (this.isChallengeSubmit) {
        listParams.sort = this.challengeSort;
      }
      // compulsory  强制用户必须全部答完才可提交(非超时自动提交的情况)
      if (type != "timeout" && type != "violation") {
        // violation 是违规（切屏次数过多）
        if (this.testExamInfo?.otherRule?.compulsory == 1) {
          this.testExamInfo.paperContext.forEach((item) => {
            item.questions.forEach((sitem) => {
              if (!sitem.questionContext?.isFinish) {
                isAllFinish = false;
                return;
              }
            });
          });
          if (!isAllFinish) {
            this.$Dialog.toast("请检查是否全部答完，未答完不允许提交试卷", {
              type: "warning",
            });
            return;
          }
        }
      }
      if (type != "timeout" && type != "violation") {
        this.$Dialog.confirm({
          message: type == "timeout" ? "考试时间到，请提交试卷" : "确认提交试卷",
          title: "提示", // 可选，不传则使用默认值'确认'
          onConfirm: () => {
            // subjectiveQuestionMarking为1需要ai判分
            if (this.testExamInfo?.otherRule?.subjectiveQuestionMarking == 1) {
              this.$refs.aiWait.aiWaitShow = true;
              this.saveExamInfo(listParams);
            } else {
              this.saveExamInfo(listParams);
            }
            // }
          }, // 确认后的操作，如调用删除API等
          onCancel: () => {
            // this.saveExamInfo(listParams);
          }, // 取消后的操作，可选不传则无动作。也可以在这里添加其他逻辑。
        });
      } else {
        // 直接提交（超时&切屏次数上限）
        this.$Dialog.toast(type == "timeout" ? "考试时间到，即将提交试卷" : "切屏次数达到上限，即将提交试卷", { type: 'warning' });
        setTimeout(() => {
          if (this.testExamInfo?.otherRule?.subjectiveQuestionMarking == 1) {
            this.$refs.aiWait.aiWaitShow = true;
            this.saveExamInfo(listParams);
          } else {
            this.saveExamInfo(listParams);
          }
        }, 1000)
      }
    },
    // 试题提交
    saveExamInfo(listParams) {
      if(this.paperType == 'examination'){
        this.$refs.aiWait.aiWaitShow = true;
        // 试卷中心考试提交
        this.$Api.examination
          .saveExamPaper(listParams)
          .then((res) => {
            if (this.$refs.aiWait) {
              this.$Dialog.toast("提交成功");
              this.$refs.aiWait.aiWaitShow = false;
            }
            this.href("/examRecordPaper",{recordId:res.data.data.recordId,testPaperType:this.paperType})
            // this.$emit("refreshTextExam");
            // setTimeout(() => {
            //   // 判断是否ai判分
            //   if (this.testExamInfo?.otherRule?.subjectiveQuestionMarking == 1) {
            //     this.loading = this.$Dialog.loading("系统判分中，请耐心等待...");
            //     this.getUserExamRecord(res?.data?.data?.recordId);
            //   } else {
            //     this.getUserExamRecord(res?.data?.data?.recordId);
            //   }
            // }, 1000);
          })
          .catch((error) => {
            console.error("提交试卷失败:", error);
            // if (!this.$Tools.empty(this.loading)) {
            //   this.loading.close();
            //   this.loading = {};
            // }
            // // this.$Dialog.toast("提交试卷失败，请重新尝试提交，若多次提交失败请联系工作人员",{type:'warning'});
            // this.$refs.aiWait.aiWaitShow = false;
            // // 确保状态更新完成后再触发退出全屏
            // this.$nextTick(() => {
            //   // 新增推出全屏方法
            //   this.$emit("exitFullScreen", this.testExamInfo.recordId,true);
            // });
          });
      }else if (this.paperType == "testPaper") {
        this.$Api.testPaper
          .submitTestPaper(listParams)
          .then((res) => {
            if (this.$refs.aiWait) {
              this.$Dialog.toast("提交成功");
              this.$refs.aiWait.aiWaitShow = false;
            }
            this.$emit("refreshTextExam");
            setTimeout(() => {
              // 判断是否ai判分
              if (this.testExamInfo?.otherRule?.subjectiveQuestionMarking == 1) {
                this.loading = this.$Dialog.loading("系统判分中，请耐心等待...");
                this.getUserExamRecord(res?.data?.data?.recordId);
              } else {
                this.getUserExamRecord(res?.data?.data?.recordId);
              }
            }, 1000);
          })
          .catch((error) => {
            console.error("提交试卷失败:", error);
            if (!this.$Tools.empty(this.loading)) {
              this.loading.close();
              this.loading = {};
            }
            // this.$Dialog.toast("提交试卷失败，请重新尝试提交，若多次提交失败请联系工作人员",{type:'warning'});
            this.$refs.aiWait.aiWaitShow = false;
            // 确保状态更新完成后再触发退出全屏
            this.$nextTick(() => {
              // 新增推出全屏方法
              this.$emit("exitFullScreen", this.testExamInfo.recordId,true);
            });
          });
      } else {
        this.$Api.exam
          .submitExamPaper(listParams)
          .then((res) => {
            if (this.$refs.aiWait) {
              this.$Dialog.toast("提交成功");
              this.$refs.aiWait.aiWaitShow = false;
            }
            this.$emit("refreshTextExam");
            setTimeout(() => {
              // 判断是否ai判分
              if (this.testExamInfo?.otherRule?.subjectiveQuestionMarking == 1) {
                this.loading = this.$Dialog.loading("系统判分中，请耐心等待...");
                this.getUserExamRecord(res?.data?.data?.recordId);
              } else {
                this.getUserExamRecord(res?.data?.data?.recordId);
              }
            }, 1000);
          })
          .catch((error) => {
            console.error("提交试卷失败:", error);
            if (!this.$Tools.empty(this.loading)) {
              this.loading.close();
              this.loading = {};
            }
            // this.$Dialog.toast("提交试卷失败，请重新尝试提交，若多次提交失败请联系工作人员",{type:'warning'});
            this.$refs.aiWait.aiWaitShow = false;
            // 确保状态更新完成后再触发退出全屏
            this.$nextTick(() => {
              // 新增推出全屏方法
              this.$emit("exitFullScreen", this.testExamInfo.recordId,true);
            });
          });
      }
    },
    // 试题提交控制显示试卷的结果分数
    changeExamInfoIsShowScoring() {
      this.testExamInfo.isShowScoring = true;
      // 默认到第一题
      this.testExamInfo.currentQuestionId = 1;
      this.$store.commit("exam/setTestExamInfo", this.testExamInfo);
    },
    // 此处新增系统判分逻辑----调用查询作答记录（后台判分）
    getUserExamRecord(recordId) {
      if (this.paperType == "testPaper") {
        this.$Api.testPaper
          .getTestPaperRecord(recordId)
          .then((res) => {
            let examInfo = res.data.data;
            examInfo.isShowScoring = true;

            // 第一次没有当前所做题目id设置第一个题目为当前所在题
            if (!examInfo.currentQuestionId) {
              examInfo.currentQuestionId =
                examInfo.paperContext[0]?.questions[0]?.questionNumber;
            }
            this.$store.commit("exam/setTestExamInfo", examInfo);

            // 确保状态更新完成后再触发退出全屏
            this.$nextTick(() => {
              // 新增推出全屏方法
              this.$emit("exitFullScreen", recordId);
            });

            if (!this.$Tools.empty(this.loading)) {
              this.loading.close();
              this.loading = {};
            }
          })
          .catch((error) => {
            console.error("获取考试记录失败:", error);
            if (!this.$Tools.empty(this.loading)) {
              this.loading.close();
              this.loading = {};
            }
          });
      } else {
        this.$Api.exam
          .getNewExamRecordInfo(recordId)
          .then((res) => {
            let examInfo = res.data.data;
            examInfo.isShowScoring = true;

            // 第一次没有当前所做题目id设置第一个题目为当前所在题
            if (!examInfo.currentQuestionId) {
              examInfo.currentQuestionId =
                examInfo.paperContext[0]?.questions[0]?.questionNumber;
            }
            this.$store.commit("exam/setTestExamInfo", examInfo);

            // 确保状态更新完成后再触发退出全屏
            this.$nextTick(() => {
              // 新增推出全屏方法
              this.$emit("exitFullScreen", recordId);
            });

            if (!this.$Tools.empty(this.loading)) {
              this.loading.close();
              this.loading = {};
            }
          })
          .catch((error) => {
            console.error("获取考试记录失败:", error);
            if (!this.$Tools.empty(this.loading)) {
              this.loading.close();
              this.loading = {};
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.answer_sheet {
  width: 330px;
  // height: 847px;
  background: #ffffff;
  border-radius: 10px;
  padding: 15px 20px;
  box-sizing: border-box;

  .timehours_icon {
    width: 22px;
    height: 22px;
  }

  .exam_time {
    font-size: 16px;
    color: #606060;
  }

  .exam_countDown {
    font-weight: 500;
    font-size: 32px;
    color: #13d6aa;
  }

  .answer_top {
    padding-bottom: 10px;
    border-bottom: 1px dashed #dedede;

    .answer_title {
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      text-align: center;
    }

    .exam_info {
      box-sizing: border-box;
      padding-left: 10px;
      line-height: 30px;
      // font-weight: 600;

      .exam_label {
        color: #999999;
      }

      .exam_value {
        color: #333333;

        .notes {
          font-size: 12px;
          color: rgb(153, 153, 153);
        }
      }
    }

    .testExam_score {
      font-size: 14px;
      color: #fd673b;

      .testExam_score_value {
        font-weight: 500;
        font-size: 32px;
        color: #fd673b;
      }
    }

    .homework_score_icon {
      width: 49px;
      height: 21px;
    }

    .marker_info {
      background: #f6faff;
      border-radius: 10px;
      font-size: 14px;
      color: #111111;

      .marker_info_content {
        width: 100%;
        overflow-wrap: anywhere;
      }

      .comments_icon {
        width: 62px;
        height: 27px;
      }
    }

    .marker_reviewer {
      .reviewer_label {
        width: 90px;
        font-size: 16px;
        color: #999999;
      }
    }
  }

  .progress_classify {
    .classify_one {
      color: #333333;
      // font-weight: 600;
    }
  }

  .topic_list {
    .topic_one {
      .topic_type {
        color: #333333;
        line-height: 24px;
      }

      .topic_sub {
        .answer_block {
          text-align: center;
          line-height: 24px;
          margin-right: 10px;
        }
      }
    }
  }

  .save_btn {
    width: 220px;
    height: 42px;
    border-radius: 21px;
    border: 1px solid #13d6aa;
    font-size: 18px;
    color: #13d6aa;
    text-align: center;
    line-height: 42px;
    margin: 80px auto 10px;
  }

  .commit_btn {
    width: 220px;
    height: 42px;
    background: #13d6aa;
    border-radius: 21px;
    font-size: 18px;
    text-align: center;
    line-height: 42px;
    color: #ffffff;
    margin: 10px auto;
  }

  .attention_text {
    font-size: 14px;
    color: #999999;
    margin: 15px auto;
    text-align: center;
  }
}

.complete_progress {
  width: 24px;
  height: 24px;
  background: rgba(0, 199, 88, 0.2);
  border-radius: 4px;
  border: 1px solid #00c758;
  color: #00c758;
}

.incomplete_progress {
  width: 24px;
  height: 24px;
  background: rgba(225, 225, 225, 0.2);
  border-radius: 4px;
  color: #999999;
  border: 1px solid #999999;
}

.current_progress {
  width: 24px;
  height: 24px;
  background: rgba(103, 139, 255, 0.2);
  border-radius: 4px;
  border: 1px solid #3a74f7;
  color: #3a74f7;
}

.wrong_progress {
  width: 24px;
  height: 24px;
  background: rgba(255, 20, 20, 0.23);
  border-radius: 4px;
  border: 1px solid #ff1414;
  color: #ff1414;
}

.marker_info {
  .markerComment {
    border: 1px solid #666;
    border-radius: 10px;
  }
}
</style>
